<template>
  <div class="h-borderBox h-subscriber-parseList">
    <div class="h-dialog-borderBox-topIcon">{{Title}}
      <div class="h-toolbarBg dialog-icon-style">
        <ejs-toolbar class="dialog-icon-style">
          <div class="dialog-icon-style" >
            <div>
              <button :title='$t("MCS.add")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='$addLine'>
                <span class="e-btn-icon icon hero-icon hero-icon-add-small e-icons"></span>
              </button>
            </div>
          </div>
        </ejs-toolbar>
      </div>
    </div>
    <div class="h-borderBox-content" style="overflow: hidden">
      <div v-for="(item ,index) in $initList" :data-i="index" class='h-subscriber-listArr'>
        <div class='h-subscriber-listParseForm'>
          <!--{{item}}-->
          <ParseForm :ref='index' :formParams='item' :funcClick='funcClick' :opCode='opCode' :parseListIndexOf='index' :formId='$formId'></ParseForm>
        </div>
        <div class="h-toolbarBg h-subscriber-listRemoveButton">
          <ejs-toolbar>
            <div>
              <div>
                <button class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='$delLine(index)' data-ripple="true" tabindex="-1" style="width: auto;" :title='$t("MCS.del")'>
                  <span class='icon hero-icon hero-icon-remove-small'></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <!--<button @click="getDatas">测试ParseList组件返回数据</button>-->
    <!--<button @click="validateResult">测试ParseList组件表单验证</button>-->
  </div>
</template>
<script>
import ParseForm from './ParseForm';
import bus from './tools/bus';
import { EventBus } from '../../../../plugins/eventBus';

const $defaultMinLength = 0;
const $defaultMaxLength = 30;
export default {
  name: 'ParseList',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'Title',
    'funcAddLine',
    'funcDelLine',
    'minLength',
    'maxLength',
    'funcClick',
    'opCode'
  ],
  data() {
    return {
      initFlag: true,
      listParams: [],
      $nowLength: 0,
      $addLineFlag: false,
      $nowClickIndex: '',
      $formId: ''
    };
  },
  methods: {
    getDatas() {
      const $this = this;
      const attrList = [];
      for (let i = 0; i < this.$nowLength; i++) {
        const _resObj = {};
        const _resMap = $this.$refs[i][0].getDatas();
        Array.from(_resMap).forEach(([key, value]) => {
          _resObj[key] = value;
        });
        attrList.push(_resObj);
      }
      const _res = {
        count: this.$nowLength,
        list: attrList
      };
      console.log('_res', _res);
      return _res;
    },
    setData(_line, _name, _data) {
      this.$refs[_line][0].setData(_name, _data);
    },
    getAttrByName(_line, _name, _type) {
      return this.$refs[_line][0].getAttrByName(_name, _type);
    },
    setAttrByName(_line, _name, _type, _value) {
      this.$refs[_line][0].setAttrByName(_name, _type, _value);
    },
    getClickIndex() {
      return this.$nowClickIndex;
    },
    validateResult() {
      let _result = true;
      for (let i = 0; i < this.$nowLength; i++) {
        if (this.$refs[i][0].validateResult() === false) {
          _result = this.$refs[i][0].validateResult();
        }
      }
      console.log(_result);
      return _result;
    },
    $addLine() {
      const $this = this;
      if (this.$nowLength >= this.maxLength) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("Profile.maxadd") + ' '+ this.maxLength + ' ' + this.$t("Profile.items")});
      } else {
        this.listParams.push(this.formParams);
        this.$addLineFlag = true;
        this.$nowLength ++;
      }
      try {
        if (this.funcAddLine !== undefined) {
          this.funcAddLine();
        }
      } catch (e) {
        console.log('funcAddLine方法报错了!');
      }
    },
    $delLine(_index) {
      const $this = this;
      if (this.$nowLength <= this.minLength) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("Profile.minadd") + ' ' + this.minLength + ' ' + this.$t("Profile.items")});
      } else {
        const _valueMapList = [];
        for (let i = 0; i < this.$nowLength; i++) {
          if (_index !== i) {
            _valueMapList.push($this.$refs[i][0].getDatas());
          }
        }
        $this.listParams.splice(_index, 1);
        $this.$nowLength --;
        for (let i = 0; i < this.$nowLength; i++) {
          $this.$refs[i][0].setDatas(_valueMapList[i]);
        }
      }
      try {
        if (this.funcDelLine !== undefined) {
          this.funcDelLine();
        }
      } catch (e) {
        console.log('funcDelLine方法报错了!');
      }
    },
    $eventListClick() {
      bus.$on('$clickBus', (_index) => {
        this.$nowClickIndex = _index;
      });
    },
    $createRandomFormId() {
      const _temp = 'abcdefghijklmnopqrstuvwxyz';
      this.$formId = '';
      for (let i = 0; i < 5; i++) {
        this.$formId += _temp[Math.round(Math.random(1) * 26)];
      };
    }
  },
  computed: {
    $initList() {
      if (this.formParams !== null && this.formParams.initFlag === undefined) {
        if (this.minLength === undefined) this.minLength = $defaultMinLength;
        if (this.formParams[0] !== undefined && this.formParams[0] !== null && this.formParams[0].valueList !== undefined && this.formParams[0].valueList.length !== 0) {
          this.$nowLength = this.formParams[0].valueList.length;
          for (let i = 0; i < this.$nowLength; i++) {
            const _tempFormParams = JSON.parse(JSON.stringify(this.formParams));
            _tempFormParams.forEach((item) => {
              item.value = item.valueList[i];
            });
            this.listParams.push(_tempFormParams);
          }
        } else {
          this.$nowLength = this.minLength;
          this.listParams = [];
          for (let i = 0; i < this.$nowLength; i++) {
            this.listParams.push(this.formParams);
          }
        }
        this.formParams.initFlag = false;
      }
      return this.listParams;
    },
  },
  updated() {
    // 如果是新增 则给新增ParseForm执行函数
    if (this.$addLineFlag === true) {
      try {
        if (this.$nowLength !== 0) {
          this.$refs[this.$nowLength - 1][0].$initFunc();
          this.$refs[this.$nowLength - 1][0].$initValidate();
        }
      } catch (e) {
        console.log('subscriber error = ', e);
      }
      this.$addLineFlag === false;
    }
  },
  created() {
    this.$createRandomFormId();
    if (this.maxLength === undefined) this.maxLength = $defaultMaxLength;
    this.$eventListClick();
  }
};
</script>

<style scoped>

</style>
